import CREDENTIAL_STATUS from './CredentialStatus';

const { REVOKING, ...FILTERABLE_CREDENTIAL_STATUS } = CREDENTIAL_STATUS;

export default FILTERABLE_CREDENTIAL_STATUS;
